import { BottomSheetModalProvider } from "@gorhom/bottom-sheet";
import type React from "react";
import { PortalProvider } from "@medbillai/ui";
import { AlertProvider } from "./alerts";
import { ApolloProvider, type ApolloProviderProps } from "./apollo";
import { UploadDocumentProvider, UploadDocumentProviderV2 } from "./documents";
import { PaymentsProvider } from "./payments";
import { SafeAreaProvider } from "./safe-area";
import { TamaguiProvider } from "./tamagui";
import { UniversalThemeProvider } from "./theme";
import { ToastProvider } from "./toast";
export type ProviderProps = ApolloProviderProps;
export function Provider({
  apolloPath,
  apolloWsPath,
  rethrowError,
  onAuthError,
  enableDevTools,
  children
}: ProviderProps) {
  return <ApolloProvider apolloPath={apolloPath} apolloWsPath={apolloWsPath} rethrowError={rethrowError} onAuthError={onAuthError} enableDevTools={enableDevTools} data-sentry-element="ApolloProvider" data-sentry-component="Provider" data-sentry-source-file="index.tsx">
      <Providers data-sentry-element="Providers" data-sentry-source-file="index.tsx">
        <BottomSheetModalProvider data-sentry-element="BottomSheetModalProvider" data-sentry-source-file="index.tsx">
          <PortalProvider data-sentry-element="PortalProvider" data-sentry-source-file="index.tsx">{children}</PortalProvider>
        </BottomSheetModalProvider>
      </Providers>
    </ApolloProvider>;
}
const compose = (providers: React.FC<{
  children: React.ReactNode;
}>[]) => providers.reduce((Prev, Curr) => ({
  children
}) => {
  const CurrProvider = Prev ? <Prev>
        <Curr>{children}</Curr>
      </Prev> : <Curr>{children}</Curr>;
  return CurrProvider;
});
const Providers = compose([UniversalThemeProvider, SafeAreaProvider, TamaguiProvider, ToastProvider, AlertProvider, PaymentsProvider, UploadDocumentProvider, UploadDocumentProviderV2]);